import styles from './Button.module.css'

interface Button {
  size: 'small' | 'medium' | 'large',
  color?: 'red' | 'redMid' | 'pink',
  onClick: () => void,
  disabled?: boolean,
  className?: string,
  children: React.ReactElement | string
}

function Button({
  size,
  color = 'red',
  onClick,
  disabled,
  className,
  children,
}: Button) {

  const cssClasses = [styles.button]
  if (size) {
    cssClasses.push(styles[size])
  }
  if (color) {
    cssClasses.push(styles[color])
  }
  if (className) {
    cssClasses.push(className)
  }
  const cssClass = cssClasses.join(" ").trim()

  return (
    <button className={cssClass} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}

export default Button
